(function () {
  var MOBILE_MQ = '(max-width: 749px)';
  var SIZE_NAME_RE = /size|サイズ|fit/;
  var COLOR_NAME_RE = /color|colour|カラー|色/;

  function isMobile() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function resolveOwnedElement(root, selector, ownerAttr) {
    var local = root.querySelector(selector);
    if (local) return local;
    if (!root.id) return null;
    return document.querySelector(selector + '[' + ownerAttr + '="' + root.id + '"]');
  }

  function resolveDock(root) {
    return resolveOwnedElement(root, '[data-atc-dock]', 'data-atc-owner');
  }

  function getBodyHost() {
    var host = document.querySelector('[data-atc-body-host]');
    if (!host) {
      host = document.createElement('div');
      host.className = 'atc-dock-host';
      host.setAttribute('data-atc-body-host', '');
      host.hidden = true;
      document.body.appendChild(host);
    }
    return host;
  }

  function getMainVariantSelects() {
    var selects = document.querySelectorAll('variant-selects');
    for (var i = 0; i < selects.length; i += 1) {
      if (selects[i].style.display !== 'none') return selects[i];
    }
    return document.querySelector('variant-selects');
  }

  function getSubmit(root) {
    return root.querySelector('[data-atc-submit]');
  }

  function getTrigger(root) {
    var dock = resolveDock(root);
    return dock ? dock.querySelector('[data-atc-trigger]') : null;
  }

  function optionLabelText(fieldset) {
    var legend = fieldset.querySelector('legend, .form__label');
    return ((legend && legend.textContent) || '').trim().toLowerCase();
  }

  function isSingleColorFieldset(fieldset) {
    return (
      fieldset.classList.contains('single-color-option') ||
      fieldset.hasAttribute('data-single-color-option') ||
      fieldset.classList.contains('single-size-option') ||
      fieldset.hasAttribute('data-single-size-option')
    );
  }

  function findSizeFieldsets() {
    var mainSelects = getMainVariantSelects();
    if (!mainSelects) return [];

    var sized = [];
    var fallback = [];

    mainSelects.querySelectorAll('fieldset.product-form__input').forEach(function (fieldset) {
      if (isSingleColorFieldset(fieldset)) return;

      var radios = fieldset.querySelectorAll('input[type="radio"]');
      if (radios.length <= 1) return;

      var name = optionLabelText(fieldset);
      if (COLOR_NAME_RE.test(name) && !SIZE_NAME_RE.test(name)) return;

      if (SIZE_NAME_RE.test(name)) {
        sized.push(fieldset);
      } else {
        fallback.push(fieldset);
      }
    });

    return sized.length ? sized : fallback;
  }

  function clearSizeSelection(fieldset) {
    fieldset.querySelectorAll('input[type="radio"]').forEach(function (radio) {
      radio.checked = false;
    });

    var selectedValue = fieldset.querySelector('[data-selected-value]');
    if (selectedValue) selectedValue.textContent = '';
  }

  function setVariantInputEnabled(enabled) {
    document.querySelectorAll('.product-variant-id').forEach(function (input) {
      if (enabled) {
        if (input.dataset.sizeGateDisabled === '1') {
          input.disabled = false;
          delete input.dataset.sizeGateDisabled;
        }
      } else if (!input.disabled) {
        input.disabled = true;
        input.dataset.sizeGateDisabled = '1';
      }
    });
  }

  function markSizePending(fieldset) {
    fieldset.dataset.sizePending = 'true';
    fieldset.classList.add('size-pending');
    clearSizeSelection(fieldset);
  }

  function clearSizePending(fieldset) {
    delete fieldset.dataset.sizePending;
    fieldset.dataset.sizeChosen = '1';
    fieldset.classList.remove('size-pending', 'size-highlight');
  }

  function pendingSizeFieldsets() {
    return findSizeFieldsets().filter(function (fieldset) {
      return fieldset.dataset.sizePending === 'true';
    });
  }

  function syncVariantGate() {
    var pending = pendingSizeFieldsets();
    setVariantInputEnabled(pending.length === 0);
  }

  function scrollToSizeFieldset(fieldset) {
    if (!fieldset) return;

    fieldset.classList.remove('size-highlight');
    // Force reflow so the animation can restart.
    void fieldset.offsetWidth;
    fieldset.classList.add('size-highlight');

    var dockOffset = 0;
    if (isMobile()) {
      var host = document.querySelector('[data-atc-body-host]');
      if (host && host.classList.contains('is-visible') && !host.hidden) {
        dockOffset = host.offsetHeight || 72;
      }
    }

    var top =
      fieldset.getBoundingClientRect().top +
      window.pageYOffset -
      Math.max(16, window.innerHeight * 0.18) -
      dockOffset * 0.15;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: 'smooth',
    });

    window.setTimeout(function () {
      fieldset.classList.remove('size-highlight');
    }, 1600);
  }

  function ensureSizeSelected() {
    var pending = pendingSizeFieldsets();
    if (!pending.length) return true;
    scrollToSizeFieldset(pending[0]);
    return false;
  }

  function hasExplicitVariantParam() {
    try {
      return new URLSearchParams(window.location.search).has('variant');
    } catch (err) {
      return false;
    }
  }

  function availableSizeRadios(fieldset) {
    var radios = Array.prototype.slice.call(fieldset.querySelectorAll('input[type="radio"]'));
    var enabled = radios.filter(function (radio) {
      return !radio.disabled && !radio.classList.contains('disabled');
    });
    return enabled.length ? enabled : radios;
  }

  function selectMiddleSize(fieldset) {
    var radios = availableSizeRadios(fieldset);
    if (!radios.length) return;
    var index = Math.floor((radios.length - 1) / 2);
    var radio = radios[index];
    if (!radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    clearSizePending(fieldset);
  }

  function applyDefaultSize() {
    var fieldsets = findSizeFieldsets();
    if (!fieldsets.length) {
      setVariantInputEnabled(true);
      return;
    }

    if (hasExplicitVariantParam()) {
      fieldsets.forEach(function (fieldset) {
        clearSizePending(fieldset);
      });
      syncVariantGate();
      return;
    }

    fieldsets.forEach(function (fieldset) {
      if (fieldset.dataset.sizeChosen === '1') return;
      selectMiddleSize(fieldset);
    });
    syncVariantGate();
  }

  function wireSizeGate() {
    var fieldsets = findSizeFieldsets();
    if (!fieldsets.length) {
      setVariantInputEnabled(true);
      return;
    }

    fieldsets.forEach(function (fieldset) {
      if (fieldset.dataset.sizeGateWired === '1') return;
      fieldset.dataset.sizeGateWired = '1';

      fieldset.addEventListener('change', function (event) {
        var input = event.target;
        if (!input || input.type !== 'radio') return;
        if (input.checked) {
          clearSizePending(fieldset);
          syncVariantGate();
        }
      });
    });

    applyDefaultSize();
    window.setTimeout(applyDefaultSize, 0);
    window.setTimeout(applyDefaultSize, 120);
    document.querySelectorAll('[data-atc]').forEach(syncStickyBar);
  }

  function syncDockHeight(dock) {
    if (!dock) return;
    document.documentElement.style.setProperty('--atc-dock-height', dock.offsetHeight + 'px');
  }

  function syncTriggerFromSubmit(root) {
    var submit = getSubmit(root);
    var trigger = getTrigger(root);
    var label = trigger ? trigger.querySelector('[data-atc-trigger-label]') : null;
    if (!submit || !trigger || !label) return;

    var submitLabel = submit.querySelector('span');
    if (submitLabel) {
      label.textContent = submitLabel.textContent;
    }

    trigger.disabled = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
    trigger.classList.toggle('loading', submit.classList.contains('loading'));
  }

  function wireTrigger(root) {
    var submit = getSubmit(root);
    var trigger = getTrigger(root);
    if (!submit || !trigger || trigger.dataset.atcWired === '1') return;

    trigger.dataset.atcWired = '1';
    trigger.addEventListener('click', function () {
      if (trigger.disabled) return;
      if (!ensureSizeSelected()) return;
      submit.click();
    });

    if (window.MutationObserver) {
      var observer = new MutationObserver(function () {
        syncTriggerFromSubmit(root);
      });
      observer.observe(submit, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class'],
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    syncTriggerFromSubmit(root);
  }

  function wireSubmitGate(root) {
    var submit = getSubmit(root);
    if (!submit || submit.dataset.sizeGateWired === '1') return;

    submit.dataset.sizeGateWired = '1';
    submit.addEventListener('click', function (event) {
      if (!ensureSizeSelected()) {
        event.preventDefault();
        event.stopPropagation();
      }
    });

    var form = submit.closest('form');
    if (form && form.dataset.sizeGateWired !== '1') {
      form.dataset.sizeGateWired = '1';
      form.addEventListener('submit', function (event) {
        if (!ensureSizeSelected()) {
          event.preventDefault();
          event.stopPropagation();
        }
      });
    }
  }

  function syncCartDrawerState() {
    var root = document.querySelector('[data-atc].is-active');
    if (root && isMobile()) {
      updateDockVisibility(root);
    }
  }

  function watchCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    if (drawer.dataset.drawerWatch !== '1') {
      drawer.dataset.drawerWatch = '1';
      if (window.MutationObserver) {
        new MutationObserver(syncCartDrawerState).observe(drawer, {
          attributes: true,
          attributeFilter: ['class'],
        });
      }
    }

    syncCartDrawerState();
  }

  function resolveStickyBar(root) {
    return resolveOwnedElement(root, '[data-sticky-bar]', 'data-sticky-owner');
  }

  function headerOffset() {
    var nodes = document.querySelectorAll(
      '.announcement-bar-section, .utility-bar, .section-header, sticky-header, .header-wrapper'
    );
    var bottom = 0;
    nodes.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.bottom > bottom) bottom = rect.bottom;
    });
    return Math.max(0, Math.round(bottom));
  }

  function atcScrolledPastHeader(root) {
    var submit = getSubmit(root);
    if (!submit) return false;
    return submit.getBoundingClientRect().bottom < headerOffset() - 8;
  }

  function shouldShowMobileDock(root) {
    var submit = getSubmit(root);
    if (!submit) return false;
    return submit.getBoundingClientRect().bottom <= 0;
  }

  function updateDockVisibility(root) {
    var host = document.querySelector('[data-atc-body-host]');
    var dock = resolveDock(root);
    if (!host || !dock) return;

    var drawer = document.querySelector('cart-drawer');
    var cartOpen = drawer && drawer.classList.contains('active');
    var visible = isMobile() && !cartOpen && shouldShowMobileDock(root);

    host.hidden = !visible;
    host.classList.toggle('is-visible', visible);
    dock.hidden = !visible;
    document.body.classList.toggle('atc-docked', visible);

    if (visible) {
      syncDockHeight(dock);
    } else {
      document.documentElement.style.removeProperty('--atc-dock-height');
    }
  }

  function wireDockVisibility(root) {
    var host = getBodyHost();
    if (host.dataset.dockScrollWired === '1') return;
    host.dataset.dockScrollWired = '1';

    var onScroll = function () {
      document.querySelectorAll('[data-atc].is-active').forEach(function (activeRoot) {
        if (isMobile()) {
          updateDockVisibility(activeRoot);
        }
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  function syncStickyBar(root) {
    var bar = resolveStickyBar(root);
    if (!bar) return;

    var submit = getSubmit(root);
    var atc = bar.querySelector('[data-sticky-bar-atc]');
    var label = bar.querySelector('[data-sticky-bar-label]');
    var submitLabel = submit ? submit.querySelector('span') : null;
    if (label && submitLabel) {
      label.textContent = submitLabel.textContent;
    }
    if (atc && submit) {
      atc.disabled = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
    }

    var priceSrc = document.querySelector('.product__info-container .price');
    var priceDest = bar.querySelector('[data-sticky-price]');
    if (priceSrc && priceDest) {
      priceDest.innerHTML = priceSrc.innerHTML;
    }

    var media = document.querySelector(
      '.product__media-item.is-active img, media-gallery .product__media-item:not([hidden]) img, media-gallery img'
    );
    var stickyImg = bar.querySelector('[data-sticky-image]');
    if (media && stickyImg) {
      stickyImg.src = media.currentSrc || media.src;
      stickyImg.alt = media.alt || stickyImg.alt;
    }
  }

  function updateStickyBarVisibility(root) {
    var bar = resolveStickyBar(root);
    if (!bar) return;
    document.documentElement.style.setProperty('--sticky-bar-top', headerOffset() + 'px');
    var visible = !isMobile() && atcScrolledPastHeader(root);
    bar.hidden = !visible;
    bar.classList.toggle('is-visible', visible);
  }

  function mountStickyBar(root) {
    var bar = resolveStickyBar(root);
    if (!bar) return;

    document.querySelectorAll('[data-sticky-bar]').forEach(function (el) {
      if (el !== bar) el.remove();
    });

    bar.dataset.stickyOwner = root.id;
    if (bar.parentElement !== document.body) {
      document.body.appendChild(bar);
    }

    if (bar.dataset.stickyWired === '1') {
      syncStickyBar(root);
      updateStickyBarVisibility(root);
      return;
    }
    bar.dataset.stickyWired = '1';

    var atc = bar.querySelector('[data-sticky-bar-atc]');
    if (atc) {
      atc.addEventListener('click', function (event) {
        if (atc.disabled) {
          event.preventDefault();
          return;
        }
        if (!ensureSizeSelected()) {
          event.preventDefault();
          event.stopPropagation();
        }
      });
    }

    var onScroll = function () {
      updateStickyBarVisibility(root);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    syncStickyBar(root);
    updateStickyBarVisibility(root);
  }

  function unmountStickyBar(root) {
    var bar = resolveStickyBar(root);
    if (!bar) return;
    bar.hidden = true;
    bar.classList.remove('is-visible');
    if (bar.parentElement === document.body && root) {
      root.appendChild(bar);
    }
  }

  function mountDock(root) {
    var dock = resolveDock(root);
    if (!dock) return;

    var host = getBodyHost();
    dock.dataset.atcOwner = root.id;
    host.dataset.atcOwner = root.id;

    if (dock.parentElement !== host) {
      host.appendChild(dock);
    }

    root.classList.add('is-active');
    wireTrigger(root);
    wireDockVisibility(root);
    updateDockVisibility(root);
  }

  function unmountDock(root) {
    var dock = resolveDock(root);
    var host = document.querySelector('[data-atc-body-host]');

    if (dock && dock.parentElement !== root) {
      root.appendChild(dock);
      dock.hidden = true;
      delete dock.dataset.atcOwner;
    }

    if (host) {
      host.hidden = true;
      host.classList.remove('is-visible');
      delete host.dataset.atcOwner;
    }

    root.classList.remove('is-active');
    document.body.classList.remove('atc-docked');
    document.documentElement.style.removeProperty('--atc-dock-height');
  }

  function refresh(root) {
    if (isMobile()) {
      mountDock(root);
      unmountStickyBar(root);
      return;
    }
    unmountDock(root);
    mountStickyBar(root);
  }

  function initStickyAtc(root) {
    if (root.dataset.atcInit === '1') return;
    root.dataset.atcInit = '1';

    if (!root.id) {
      root.id = 'atc-' + Math.random().toString(36).slice(2, 9);
    }

    wireSizeGate();
    wireSubmitGate(root);
    refresh(root);

    window.addEventListener(
      'resize',
      function () {
        refresh(root);
      },
      { passive: true }
    );

    var dock = resolveDock(root);
    if (dock && window.ResizeObserver) {
      new ResizeObserver(function () {
        if (root.classList.contains('is-active') && isMobile()) {
          updateDockVisibility(root);
        }
      }).observe(dock);
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-atc]').forEach(initStickyAtc);
    watchCartDrawer();
  }

  document.addEventListener('variant:change', function () {
    document.querySelectorAll('[data-atc]').forEach(function (root) {
      if (isMobile()) {
        syncTriggerFromSubmit(root);
        updateDockVisibility(root);
        return;
      }
      mountStickyBar(root);
      syncStickyBar(root);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
